const apiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');
let serverPort;

switch (window.location.hostname) {
    case 'pmiprojectmanagementgame.pmzone.com':
    case 'projectmanagementgame.pmzone.com':
        serverPort = '3001';
        document.title = 'PMZone';
        break;
    case 'almost.pmzone.com':
        serverPort = '3300';
        document.title = 'PMZone STAGING';
        break;
    default:
        serverPort = '3200';
        document.title = 'PMZone DEV';
        break;
}
let prefix;
let socketPrefix;

if (
    window.location.hostname == 'pmiprojectmanagementgame.pmzone.com' ||
    window.location.hostname == 'projectmanagementgame.pmzone.com'
) {
    prefix = apiUrl || `${window.location.protocol}//server.${window.location.hostname}`;
    socketPrefix = 'https://projectmanagementgame.pmzone.com:3001/';
} else {
    prefix = apiUrl || `${window.location.protocol}//${window.location.hostname}:${serverPort}`;
    socketPrefix = prefix;
}

// prefix = 'https://existence-shoot-progress-protective.trycloudflare.com';

const config = {
    prefix,
    socketPrefix,
    paths: {
        register: '/auth/register',
        cardsEndpoint: '/project',
        executeTask: '/game/planned_task',
        tasks: '/project',
    },
    url: {
        params: {
            encryptedGameUid: 'encryptedGameUid',
        },
    },
};

// Add the prefix to all paths
// Run a loop on all paths
Object.keys(config.paths).map(current => {
    config.paths[current] = prefix + config.paths[current];
});

export default config;
